import React, { useContext, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useHandleUrl } from '../../hooks/useHandleUrl'
import { useTotalMo } from 'hooks/useTotalMo'
import ArticulosTableLoader from '../Loaders/ArticulosTableLoader'
import {
  createMultipleBoq,
  deleteAllBoqByProjectAndVersion,
} from '../../api/jitApi'
import {
  addModuloToBoq,
  getBimLinksProblemsByElementV2,
  handleCreateArticulosByGroup3,
  handleCreateBoq,
} from '../../utils/handleBoq'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import TotalMo from '../Articulos/TotalMo'
import { CustomButton } from '../ui'
import FabricaMatriculasTable from './FabricaTable/FabricaMatriculasTable'
import AddIcon from '@mui/icons-material/Add'
import AdjustIcon from '@mui/icons-material/Adjust'
import MarginIcon from '@mui/icons-material/Margin'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred'
import { getModuloByProjectAndVersion } from 'api/estructuraCostes/modulosJitApi'
import { redondearDecimalesToLocaleString } from 'utils/roundNumber'
import { ViewerContext } from 'context/ViewerContext'
import { useVersionModel } from 'hooks/useVersionModel'
import FabricaPdfButton from 'components/pdf/FabricaPdfButton'
import { useGetDataBoq } from 'hooks/useGetDataBoq'
import generateExcelBoqsProblems from 'utils/generateExcelBoqsProblems'
import { useAuth0 } from '@auth0/auth0-react'
import { useProject } from 'context/ProyectoContext'

const Fabrica = () => {
  const [generatingExcel, setGeneratingExcel] = useState(false)
  const [creatingBoqs, setCreatingBoqs] = useState(false)
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { currentVersion } = useVersionModel()
  const location = useLocation()
  const { changeLocation } = useHandleUrl()
  const { idProject } = useParams()
  const { totalMo } = useTotalMo()
  const { externalIdsMapping } = useContext(ViewerContext)
  const { getAllDbIdsByTipo } = useGetDataBoq()

  const { data: modulos, isFetching } = useQuery(
    ['modulos-articulos', idProject, currentVersion],
    () => getModuloByProjectAndVersion(idProject, currentVersion)
  )

  const { user } = useAuth0()
  const { currentProject, isLoadingCurrentProject } = useProject()

  const handleOnBoq = async () => {
    setCreatingBoqs(true)
    const loadingToast = toast.loading('Creando Boq')
    // * Sacar todos los elementos que tengan el parámetro BimLink
    try {
      const valuesWithBimlinks = await getAllDbIdsByTipo(true)

      // * Crear los articulos que tengan el tipo 3 y no estén en BD
      await handleCreateArticulosByGroup3(valuesWithBimlinks)
      // console.log('Salgo de handleCreateArticulosByGroup3')

      // * Añadir los articulos a BD
      const allBoqWithQuantity = await handleCreateBoq(valuesWithBimlinks)

      // * Sacar para cada externalId su módulo
      const modulos =
        queryClient.getQueryData([
          'modulos-articulos',
          idProject,
          currentVersion,
        ]) || []

      // ! ADRIÁN: Aquí es donde se añade el módulo a cada boq
      const allBoqWithModulo = await addModuloToBoq(
        allBoqWithQuantity,
        modulos.modulos
      )

      let boqWithVersion = allBoqWithModulo
        .filter(item => item !== null)
        .map(boq => ({
          ...boq,
          version: Number(currentVersion),
          proyecto: idProject,
        }))

      // // * Eliminar todas las boq por proyecto y versión
      await deleteAllBoqByProjectAndVersion(idProject, currentVersion)

      // // * Crear las boq
      console.log('Boq a crear: ', boqWithVersion.length)
      await createMultipleBoq(boqWithVersion)
      toast.dismiss(loadingToast)
      queryClient.invalidateQueries([
        'modulos-articulos',
        idProject,
        currentVersion,
      ])

      toast.success(`${boqWithVersion.length} boq creadas correctamente`)
    } catch (e) {
      queryClient.invalidateQueries([
        'modulos-articulos',
        idProject,
        currentVersion,
      ])
      toast.dismiss(loadingToast)
      toast.error('Hubo un error al crear las boq. Vuelve a intentarlo')
    } finally {
      setCreatingBoqs(false)
    }
  }

  const handleGetBoqProblems = async () => {
    const loadingToast = toast.loading('Generando reporte..')
    setGeneratingExcel(true)
    console.time('generate excel... 📄')
    try {
      let dbIdWithBimlinks = await getAllDbIdsByTipo(true)
      const problems = await Promise.all(
        dbIdWithBimlinks.map(item => getBimLinksProblemsByElementV2(item))
      )

      generateExcelBoqsProblems(problems.flat())
    } catch (err) {
      console.error('Error al obtener propiedades:', err)
    } finally {
      toast.dismiss(loadingToast)
      console.timeEnd('generate excel... 📄')
      setGeneratingExcel(false)
    }
  }

  const totalImportProject = useMemo(() => {
    if (!modulos) return 0
    return modulos.modulos.reduce((acc, modulo) => {
      return acc + Number(modulo.totalImport)
    }, 0)
  }, [modulos])

  if (!modulos || isFetching || isLoadingCurrentProject)
    return <ArticulosTableLoader />
  return (
    <>
      <div className="fabrica-page-wrapper">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CustomButton
            onClick={handleOnBoq}
            type="secondary"
            className="btn-center"
            disabled={!externalIdsMapping || creatingBoqs}
          >
            <AddIcon />
            Crear BoQ
          </CustomButton>

          {!isLoadingCurrentProject &&
            currentProject.user.includes(user.sub) && (
              <div className="fabrica-report-button-wrapper">
                <CustomButton
                  // type="secondary"
                  className="btn-center"
                  disabled={!externalIdsMapping || generatingExcel}
                  onClick={handleGetBoqProblems}
                >
                  <ReportGmailerrorredIcon /> Incidencias
                </CustomButton>
              </div>
            )}
        </div>
        <br />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <div className="fabrica-page-title">
            <div className="fabrica-page-title-buttons">
              <CustomButton
                onClick={() =>
                  navigate(
                    changeLocation(`${location.pathname}/gestionar-celulas`)
                  )
                }
                className="btn-center"
              >
                <AdjustIcon />
                Gestionar células
              </CustomButton>
              <TotalMo />
              <CustomButton
                onClick={() =>
                  navigate(
                    changeLocation(`${location.pathname}/config-matriculas`)
                  )
                }
                className="btn-center"
              >
                <MarginIcon />
                Gestionar matrículas
              </CustomButton>
              {/* {!isLoadingCurrentProject &&
                currentProject.user.includes(user.sub) && (
                  <div className="fabrica-report-button-wrapper">
                    <CustomButton
                      // type="secondary"
                      className="btn-center"
                      disabled={!externalIdsMapping || generatingExcel}
                      onClick={handleGetBoqProblems}
                    >
                      <ReportGmailerrorredIcon />
                      Reporte problemas
                    </CustomButton>
                  </div>
                )} */}
            </div>
            <FabricaPdfButton modulos={modulos} />
          </div>
          {modulos && totalMo && (
            <p className="fabrica-importe-total">
              {redondearDecimalesToLocaleString(
                totalImportProject + Number(totalMo)
              )}
            </p>
          )}
          {modulos && <FabricaMatriculasTable />}
        </div>
      </div>
    </>
  )
}

export default Fabrica
